import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { platformName } from '../platformMeta';
import { rolloutMessages } from '../releases/plan/rollout/rolloutMessages';
import { SocialPlatform } from '../types';
import { ComposerPostingModes } from './composerPostingModes';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole Promote pillar; each part uses its own slice of it */
import styles from '../Promote.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ComposerPostingModesLineProps {
  modes: ComposerPostingModes;
}

/**
 * Under the channel chips: which picked channels post by themselves, and which come to the artist
 * as a "post it yourself" reminder at their time (QA finding B11). The words are the words of the
 * Release plan, so both screens say the same thing.
 */
const ComposerPostingModesLineComponent: React.FC<ComposerPostingModesLineProps> = ({ modes }) => {
  const intl = useIntl();
  if (modes.auto.length === 0 && modes.manual.length === 0) {
    return null;
  }
  const names = (platforms: SocialPlatform[]) => intl.formatList(platforms.map(platformName));

  return (
    <p className={styles.aiHint} data-testid="composer-posting-modes">
      {modes.auto.length > 0 && (
        <span data-testid="composer-posting-auto">
          <b>{intl.formatMessage(rolloutMessages.channelsAuto)}</b> {names(modes.auto)}.{' '}
        </span>
      )}
      {modes.manual.length > 0 && (
        <span data-testid="composer-posting-manual">
          <b>{intl.formatMessage(rolloutMessages.channelsManual)}</b> {names(modes.manual)}.
        </span>
      )}
    </p>
  );
};

export const ComposerPostingModesLine = TypedMemo(ComposerPostingModesLineComponent);
